module.exports = __webpack_public_path__ + "img/withdraw2.d4119862.jpg";